const mutations = {
  STORE_VIDEO_TAXONOMY(state, { contentId, addedSkills }) {
    if (!state.videoTaxonomy || state.videoTaxonomy.contentId !== contentId) {
      state.videoTaxonomy = { contentId, addedSkills: [...addedSkills] }
    } else {
      state.videoTaxonomy.addedSkills = [...state.videoTaxonomy.addedSkills, ...addedSkills]
    }
  },
  STORE_LAB_TAXONOMY(state, { contentId, addedSkills }) {
    if (!state.labTaxonomy || state.labTaxonomy.contentId !== contentId) {
      state.labTaxonomy = { contentId, addedSkills: [...addedSkills] }
    } else {
      state.labTaxonomy.addedSkills = [...state.labTaxonomy.addedSkills, ...addedSkills]
    }
  },
  CLEAR_LAB_TAXONOMY(state, { contentId }) {
    if (!state.labTaxonomy || state.labTaxonomy.contentId !== contentId) {
      state.labTaxonomy = { contentId, addedSkills: [] }
    } else {
      state.labTaxonomy.addedSkills = []
    }
  },
  CLEAR_VIDEO_TAXONOMY(state, { contentId }) {
    if (!state.videoTaxonomy || state.videoTaxonomy.contentId !== contentId) {
      state.videoTaxonomy = { contentId, addedSkills: [] }
    } else {
      state.videoTaxonomy.addedSkills = []
    }
  },
  DELETE_LAB_TAXONOMY_SKILL(state, {contentId, skillId}) {
    if (!state.labTaxonomy || state.labTaxonomy.contentId !== contentId || !state.labTaxonomy.addedSkills) {
      state.labTaxonomy = { contentId, addedSkills: [] }
    } else {
      state.labTaxonomy.addedSkills = state.labTaxonomy.addedSkills.filter(s => s.skillId !== skillId)
    }
  },
  DELETE_VIDEO_TAXONOMY_SKILL(state, {contentId, skillId}) {
    if (!state.videoTaxonomy || state.videoTaxonomy.contentId !== contentId || !state.videoTaxonomy.addedSkills) {
      state.videoTaxonomy = { contentId, addedSkills: [] }
    } else {
      state.videoTaxonomy.addedSkills = state.videoTaxonomy.addedSkills.filter(s => s.skillId !== skillId)
    }
  },
}

export default mutations
